Vue.component('adminFrames', {
  template: templates.adminFrames,
  data() {
    return {
      activeTab: 'backgrounds', // 'backgrounds' or 'frames'
      model: {
        edit: false,
        // Background model
        background: {
          id: null,
          name: null,
          description: null,
          active: false,
          resolution: '1920x1080'
        },
        backgrounds: {},
        // Frame model
        frame: {
          id: null,
          name: null,
          description: null,
          active: false
        },
        frames: {}
      }
    }
  },
  mounted() {
    const c = this;
    c.getBackgrounds();
    c.getFrames();

    // Listen for upload completion events
    c.$root.$on('background-upload-success', data => {
      c.handleBackgroundUpload(data);
    });

    c.$root.$on('frame-upload-success', data => {
      c.handleFrameUpload(data);
    });
  },
  methods: {
    // Tab switching
    switchTab(tab) {
      this.activeTab = tab;
      this.model.edit = false;
    },

    // ========== BACKGROUNDS ==========
    getBackgrounds() {
      const c = this;
      let data = {};

      backgroundService.get()
        .then(function (response) {
          for (let d of response.data) {
            // Set up image paths using stored extensions
            d.backgroundImage = d.extension
              ? `${root}/images/backgrounds/${d.id}/${d.id}.${d.extension}?t=${Date.now()}`
              : null;
            data[`${d.id}`] = d;
          }
          c.model.backgrounds = data;
        })
        .catch(function (error) {
          console.error('Error loading backgrounds:', error);
        });
    },

    editBackground(id) {
      const c = this;
      let data = c.model.backgrounds[`${id}`];

      if (id == c.model.background.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      c.model.background = {
        id: id,
        name: data.name,
        description: data.description,
        active: data.active,
        resolution: data.resolution || '1920x1080'
      };
    },

    addBackground() {
      const c = this;
      c.resetBackground();
      c.model.edit = true;
    },

    saveBackground() {
      const c = this;
      const data = c.model.background;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }

      if (!data.description) {
        utils.alert.error('Description is required');
        return;
      }

      backgroundService.save(data)
        .then(function (response) {
          if (data.id) {
            c.model.backgrounds[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.backgrounds[`${data.id}`] = data;
          }

          c.resetBackground();
          utils.alert.success('Background saved! You can now upload the image.');
          c.getBackgrounds();
        })
        .catch(function (error) {
          utils.alert.error('Failed to save background.');
        });
    },

    handleBackgroundUpload(data) {
      const c = this;

      // Immediately update the background entry with the new image path
      if (c.model.backgrounds[`${data.id}`]) {
        const ext = data.filename ? data.filename.split('.').pop() : null;
        Vue.set(c.model.backgrounds[`${data.id}`], 'backgroundImage',
          `${root}/images/backgrounds/${data.id}/${data.id}.${ext}?t=${Date.now()}`
        );
      }

      // Refresh all backgrounds data from server
      c.getBackgrounds();
    },

    resetBackground() {
      const c = this;
      c.model.edit = false;
      c.model.background = {
        id: null,
        name: null,
        description: null,
        active: false,
        resolution: '1920x1080'
      };
    },

    deleteBackground(id) {
      const c = this;

      if (!confirm('Are you sure you want to delete this background?')) {
        return;
      }

      backgroundService.delete(id)
        .then(function (response) {
          Vue.delete(c.model.backgrounds, id);
          utils.alert.success('Background deleted successfully!');

          if (c.model.background.id === id) {
            c.resetBackground();
          }
        })
        .catch(function (error) {
          utils.alert.error('Failed to delete background.');
        });
    },

    // ========== FRAMES ==========
    getFrames() {
      const c = this;
      let data = {};

      frameService.get()
        .then(function (response) {
          for (let d of response.data) {
            // Set up image paths using stored extensions
            d.frameImage = d.uploaded && d.extension
              ? `${root}/images/frames/${d.id}/${d.id}.${d.extension}?t=${Date.now()}`
              : null;
            data[`${d.id}`] = d;
          }
          c.model.frames = data;
        })
        .catch(function (error) {
          console.error('Error loading frames:', error);
        });
    },

    editFrame(id) {
      const c = this;
      let data = c.model.frames[`${id}`];

      if (id == c.model.frame.id) {
        c.model.edit = false;
      } else {
        c.model.edit = true;
      }

      c.model.frame = {
        id: id,
        name: data.name,
        description: data.description,
        active: data.active
      };
    },

    addFrame() {
      const c = this;
      c.resetFrame();
      c.model.edit = true;
    },

    saveFrame() {
      const c = this;
      const data = c.model.frame;

      if (!data.name) {
        utils.alert.error('Name is required');
        return;
      }

      if (!data.description) {
        utils.alert.error('Description is required');
        return;
      }

      frameService.save(data)
        .then(function (response) {
          if (data.id) {
            c.model.frames[`${data.id}`] = data;
          } else {
            data.id = response.data.id;
            c.model.frames[`${data.id}`] = data;
          }

          c.resetFrame();
          utils.alert.success('Frame saved! You can now upload the frame image.');
          c.getFrames();
        })
        .catch(function (error) {
          utils.alert.error('Failed to save frame.');
        });
    },

    handleFrameUpload(data) {
      const c = this;

      // Immediately update the frame entry with the new image path
      if (c.model.frames[`${data.id}`]) {
        const ext = data.filename ? data.filename.split('.').pop() : null;
        Vue.set(c.model.frames[`${data.id}`], 'frameImage',
          `${root}/images/frames/${data.id}/${data.id}.${ext}?t=${Date.now()}`
        );
        Vue.set(c.model.frames[`${data.id}`], 'uploaded', true);
      }

      // Refresh all frames data from server
      c.getFrames();
    },

    resetFrame() {
      const c = this;
      c.model.edit = false;
      c.model.frame = {
        id: null,
        name: null,
        description: null,
        active: false
      };
    },

    deleteFrame(id) {
      const c = this;

      if (!confirm('Are you sure you want to delete this frame?')) {
        return;
      }

      frameService.delete(id)
        .then(function (response) {
          Vue.delete(c.model.frames, id);
          utils.alert.success('Frame deleted successfully!');

          if (c.model.frame.id === id) {
            c.resetFrame();
          }
        })
        .catch(function (error) {
          utils.alert.error('Failed to delete frame.');
        });
    }
  }
});
